module.exports = __webpack_public_path__ + "img/avatar.a1db65f8.jpg";